import {
  makeResetStyles, shorthands,
} from '@fluentui/react-components';

export const useExplorePromptsStyles = makeResetStyles({
  '& .title': {
    marginBottom: '24px',
    '& span': {
      color: '#605E5C',
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '24px',
      letterSpacing: '-0.16px',
    },
  },
  '& .tiles-grid-cell': {
    '&:hover, &:focus-within': {
      '& .image-with-prompt .prompt-overlay': {
        animationName: [{
          '0%': { opacity: '0' },
          '100%': { opacity: '1' },
        }],
        animationDuration: '0.5s',
        animationTimingFunction: 'ease-in-out',
        '& .example-prompt-template': { // Need height for ellipsis calculation to work
          animationName: [{
            '0%': { transform: 'translateY(10px)' },
            '100%': { transform: 'translateY(0px)' },
          }],
          animationDuration: '0.5s',
          animationTimingFunction: 'ease-in-out',
        },
        visibility: 'visible',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        position: 'absolute',
        padding: '14px',
        fontSize: '16px',
        fontWeight: '600',
        color: '#FFF',
        backgroundImage: 'var(--gradient, linear-gradient(180deg, #F8ADFA -4.49%, rgba(168, 110, 221, 0.00) 13.18%), radial-gradient(166.31% 133.62% at 82.99% -9.79%, #8C48FF 6.62%, #F2598A 50%, #FFB152 89.58%))',
      },
    },
    '& .image-with-prompt': {
      width: '100%',
      height: '100%',
      position: 'relative',
      ...shorthands.borderRadius('8px', '8px', '8px', '8px'),
      ...shorthands.overflow('hidden', 'hidden'),
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      '& .prompt-overlay': {
        visibility: 'hidden',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: 'absolute',
        padding: '14px',
        fontSize: '16px',
        fontWeight: '600',
        '& .example-prompt-template': { // Need height for ellipsis calculation to work
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        },
      },
    },
  },
});
